export const getCommandBarItems = (
  translator,
  onChangeHearingOwner,
  onDeleteHearing,
  canChangeHearingOwner,
  canDeleteHearing,
) => {
  return [
    {
      key: 'changeHearingOwner',
      name: translator('pages.administration.changeOwner'),
      iconProps: {
        iconName: 'Contact',
      },
      onClick: onChangeHearingOwner,
      disabled: !canChangeHearingOwner,
      buttonStyles,
    },
    {
      key: 'deleteHearing',
      name: translator('pages.administration.deleteHearing'),
      iconProps: {
        iconName: 'Delete',
      },
      disabled: !canDeleteHearing,
      onClick: onDeleteHearing,
      buttonStyles,
    },
  ];
};

const buttonStyles = {
  root: {
    backgroundColor: '#FAFAFA',
  },
  rootDisabled: {
    backgroundColor: '#FAFAFA',
  },
};
